import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  AssistantPlanHold,
  PlanWatchHolder,
  WatchPatchEvent
} from '@core/models/plan-edit.model';

export const PlanEditActions = createActionGroup({
  source: 'PlanEdit',
  events: {
    'Assistant Holders Changed': props<{ holds: AssistantPlanHold[] }>(),
    'Plan Saved': props<{ planId: string; planDataRevision: string }>(),
    'Plan Updated Remotely': props<{ planId: string; planDataRevision: string }>(),
    'Plan Data Replaced': props<{ planId: string }>(),
    'Plan Refreshed': props<{ planId: string; planDataRevision: string }>()
  }
});

export const PlanWatchActions = createActionGroup({
  source: 'PlanWatch',
  events: {
    'Watch Requested': props<{ planId: string }>(),
    'Watch Stopped': emptyProps(),
    'Socket Connected': emptyProps(),
    Watching: props<{
      planId: string;
      holder: PlanWatchHolder | null;
      /** The session's flavours, the only ones its patches carry; empty when nobody holds the plan. */
      projections: string[];
      live: boolean;
      snapshot: WatchPatchEvent | null;
    }>(),
    'Watch Started': props<{ planId: string; holder: PlanWatchHolder }>(),
    'Watch Patch': props<{ planId: string } & WatchPatchEvent>(),
    'Watch Saved': props<{ planId: string; revision: number; planDataRevision: string }>(),
    'Watch Ended': props<{ planId: string; reason: 'closed' | 'lost' }>(),
    'Watch Recompute Failed': props<{ planId: string }>(),
    'Watch Rejected': props<{ errorCode: string }>(),
    'Overlay Released': props<{ planId: string }>()
  }
});
